import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { env } from './env';

export const appInsights: ApplicationInsights | null = env.appInsights.connectionString
  ? new ApplicationInsights({
      config: {
        connectionString: env.appInsights.connectionString,
        enableAutoRouteTracking: true,
      },
    })
  : null;

if (appInsights) {
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}
